<template>
  <div
    id="MainMenu"
    ref="MainContent"
    class="fixed top-0 bottom-0 left-0 right-0 z-40 flex items-center justify-center transform -translate-x-full"
  >
    <div class="">
      <span
        data-frame
        class="h-[2px] bg-white absolute sm:top-10 top-5 z-[41] sm:left-[100px] left-[50px] right-1/2 block frame"
      ></span>
      <span
        data-frame
        class="h-[2px] sm:w-[30px] w-[15px] bg-white absolute sm:top-10 top-5 sm:left-[35px] left-[17.5px] z-[41] block frame"
      ></span>
      <span
        data-frame
        class="sm:h-[30px] h-[15px] w-[2px] bg-white absolute sm:top-10 top-5 sm:left-[35px] left-[17.5px] z-[41] block frame"
      ></span>
      <p
        class="frame sm:text-base text-sm font-audiowide text-white absolute z-[41] sm:top-[60px] top-10 sm:left-[100px] left-10"
      >
        SAVAGE BULL
      </p>

      <span
        data-frame
        class="h-[2px] md:bg-main-color bg-white absolute sm:top-10 top-5 z-[41] left-1/2 sm:right-[200px] right-[100px] block frame"
      ></span>
      <button
        data-frame
        @mouseenter="hover_close_btn = true"
        @mouseleave="hover_close_btn = false"
        @click="Close()"
        class="absolute sm:top-10 sm:right-10 top-5 right-5 z-[41] flex items-center justify-center sm:w-[100px] sm:h-[100px] w-[60px] h-[60px] frame"
      >
        <span
          class="h-[2px] sm:w-[20px] w-[10px] md:bg-main-color bg-white absolute top-0 left-0 z-[41] transform transition-transform duration-300"
          :class="hover_close_btn ? 'translate-y-1 translate-x-1' : ''"
        ></span>
        <span
          class="sm:h-[20px] h-[10px] w-[2px] md:bg-main-color bg-white absolute top-0 left-0 z-[41] transform transition-transform duration-300"
          :class="hover_close_btn ? 'translate-x-1 translate-y-1' : ''"
        ></span>
        <span
          class="h-[2px] sm:w-[20px] w-[10px] md:bg-main-color bg-white absolute top-0 right-0 z-[41] transform transition-transform duration-300"
          :class="hover_close_btn ? 'translate-y-1 -translate-x-1' : ''"
        ></span>
        <span
          class="sm:h-[20px] h-[10px] w-[2px] md:bg-main-color bg-white absolute top-0 right-0 z-[41] transform transition-transform duration-300"
          :class="hover_close_btn ? 'translate-y-1 -translate-x-1' : ''"
        ></span>
        <close_icon class="text-4xl text-white md:text-main-color" />
        <span
          class="h-[2px] sm:w-[20px] w-[10px] md:bg-main-color bg-white absolute bottom-0 left-0 z-[41] transform transition-transform duration-300"
          :class="hover_close_btn ? '-translate-y-1 translate-x-1' : ''"
        ></span>
        <span
          class="sm:h-[20px] h-[10px] w-[2px] md:bg-main-color bg-white absolute bottom-0 left-0 z-[41] transform transition-transform duration-300"
          :class="hover_close_btn ? '-translate-y-1 translate-x-1' : ''"
        ></span>
        <span
          class="h-[2px] sm:w-[20px] w-[10px] md:bg-main-color bg-white absolute bottom-0 right-0 z-[41] transform transition-transform duration-300"
          :class="hover_close_btn ? '-translate-y-1 -translate-x-1' : ''"
        ></span>
        <span
          class="sm:h-[20px] h-[10px] w-[2px] md:bg-main-color bg-white absolute bottom-0 right-0 z-[41] transform transition-transform duration-300"
          :class="hover_close_btn ? '-translate-y-1 -translate-x-1' : ''"
        ></span>
      </button>

      <span
        data-frame
        class="w-[2px] md:bg-main-color bg-white absolute sm:top-[200px] top-[100px] z-[41] sm:right-10 right-5 sm:bottom-10 bottom-5 block frame"
      ></span>
      <span
        data-frame
        class="bottom_line h-[2px] md:bg-main-color bg-white absolute sm:bottom-10 bottom-5 z-[41] sm:right-10 right-5 frame md:block hidden"
      ></span>
      <span
        data-frame
        class="h-[30px] w-[2px] md:bg-main-color bg-white absolute bottom-10 z-[41] md:block hidden frame"
        style="left: calc(50% + 40px)"
      ></span>

      <span
        data-frame
        class="h-[2px] md:bg-main-color bg-white absolute sm:bottom-10 bottom-5 z-[41] sm:right-10 right-5 sm:left-10 left-5 frame md:hidden block"
      ></span>
      <span
        data-frame
        class="h-[30px] w-[2px] md:bg-main-color bg-white absolute sm:bottom-10 bottom-5 sm:left-10 left-5 z-[41] md:hidden block frame"
      ></span>

      <svg
        data-frame
        class="absolute sm:right-14 sm:bottom-14 right-10 bottom-10 z-[41] lg:w-40 w-20 block frame"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 59.33 59.33"
      >
        <polygon
          class="cls-1 md:fill-main-color fill-white"
          points="46.28 0 0 46.28 0 51.66 51.66 0 46.28 0"
        />
        <polygon
          class="cls-1 md:fill-main-color fill-white"
          points="59.33 8.06 8.06 59.33 13.44 59.33 59.33 13.44 59.33 8.06"
        />
        <polygon
          class="cls-1 md:fill-main-color fill-white"
          points="59.33 0 56.84 0 0 56.84 0 59.33 2.88 59.33 59.33 2.88 59.33 0"
        />
        <polygon
          class="cls-1 md:fill-main-color fill-white"
          points="59.33 18.61 18.61 59.33 23.99 59.33 59.33 23.99 59.33 18.61"
        />
        <polygon
          class="cls-1 md:fill-main-color fill-white"
          points="35.73 0 0 35.73 0 41.11 41.11 0 35.73 0"
        />
        <polygon
          class="cls-1 md:fill-main-color fill-white"
          points="4.07 0 0 4.07 0 9.45 9.45 0 4.07 0"
        />
        <polygon
          class="cls-1 md:fill-main-color fill-white"
          points="25.18 0 0 25.18 0 30.56 30.56 0 25.18 0"
        />
        <polygon
          class="cls-1 md:fill-main-color fill-white"
          points="14.63 0 0 14.63 0 20 20 0 14.63 0"
        />
        <polygon
          class="cls-1 md:fill-main-color fill-white"
          points="59.33 29.16 29.16 59.33 34.54 59.33 59.33 34.54 59.33 29.16"
        />
        <polygon
          class="cls-1 md:fill-main-color fill-white"
          points="59.33 50.27 50.27 59.33 55.65 59.33 59.33 55.65 59.33 50.27"
        />
        <polygon
          class="cls-1 md:fill-main-color fill-white"
          points="59.33 39.71 39.71 59.33 45.09 59.33 59.33 45.09 59.33 39.71"
        />
      </svg>

      <div
        data-frame
        class="social_box flex items-center justify-start absolute sm:bottom-14 bottom-10 z-[41] frame"
        v-if="footer_data != null"
      >
        <a
          @mouseenter="hover = 'facebook'"
          @mouseleave="hover = ''"
          :href="footer_data.company_facebook.content"
          target="_blank"
          class="mr-4 cursor-pointer"
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25 12.5C25 5.625 19.375 0 12.5 0C5.625 0 0 5.625 0 12.5C0 18.75 4.53125 23.9062 10.4688 24.8438V16.0937H7.34375V12.5H10.4688V9.6875C10.4688 6.5625 12.3438 4.84375 15.1563 4.84375C16.5625 4.84375 17.9688 5.15625 17.9688 5.15625V8.28125H16.4062C14.8438 8.28125 14.375 9.21875 14.375 10.1562V12.5H17.8125L17.1875 16.0937H14.2188V25C20.4688 24.0625 25 18.75 25 12.5Z"
              class="duration-300 transition-color"
              :class="
                hover == 'facebook'
                  ? 'md:fill-main-color fill-white md:opacity-100 opacity-30'
                  : 'md:fill-zinc-400 fill-white'
              "
            />
          </svg>
        </a>
        <a
          @mouseenter="hover = 'instagram'"
          @mouseleave="hover = ''"
          :href="footer_data.company_instagram.content"
          target="_blank"
          class="mr-4 cursor-pointer"
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5 2.25904C15.8133 2.25904 16.2651 2.25904 17.6205 2.25904C18.8253 2.25904 19.4277 2.56024 19.8795 2.71084C20.4819 3.01205 20.9337 3.16265 21.3855 3.61446C21.8374 4.06627 22.1386 4.51807 22.2892 5.12048C22.4398 5.57229 22.5904 6.1747 22.741 7.37952C22.741 8.73494 22.741 9.03614 22.741 12.5C22.741 15.9639 22.741 16.2651 22.741 17.6205C22.741 18.8253 22.4398 19.4277 22.2892 19.8795C21.988 20.4819 21.8374 20.9337 21.3855 21.3855C20.9337 21.8374 20.4819 22.1386 19.8795 22.2892C19.4277 22.4398 18.8253 22.5904 17.6205 22.741C16.2651 22.741 15.9639 22.741 12.5 22.741C9.03614 22.741 8.73494 22.741 7.37952 22.741C6.1747 22.741 5.57229 22.4398 5.12048 22.2892C4.51807 21.988 4.06627 21.8374 3.61446 21.3855C3.16265 20.9337 2.86145 20.4819 2.71084 19.8795C2.56024 19.4277 2.40964 18.8253 2.25904 17.6205C2.25904 16.2651 2.25904 15.9639 2.25904 12.5C2.25904 9.03614 2.25904 8.73494 2.25904 7.37952C2.25904 6.1747 2.56024 5.57229 2.71084 5.12048C3.01205 4.51807 3.16265 4.06627 3.61446 3.61446C4.06627 3.16265 4.51807 2.86145 5.12048 2.71084C5.57229 2.56024 6.1747 2.40964 7.37952 2.25904C8.73494 2.25904 9.18675 2.25904 12.5 2.25904ZM12.5 0C9.03614 0 8.73494 0 7.37952 0C6.0241 0 5.12048 0.301206 4.36747 0.60241C3.61446 0.903615 2.86145 1.35542 2.10843 2.10843C1.35542 2.86145 1.05422 3.46386 0.60241 4.36747C0.301206 5.12048 0.150602 6.0241 0 7.37952C0 8.73494 0 9.18675 0 12.5C0 15.9639 0 16.2651 0 17.6205C0 18.9759 0.301206 19.8795 0.60241 20.6325C0.903615 21.3855 1.35542 22.1386 2.10843 22.8916C2.86145 23.6446 3.46386 23.9458 4.36747 24.3976C5.12048 24.6988 6.0241 24.8494 7.37952 25C8.73494 25 9.18675 25 12.5 25C15.8133 25 16.2651 25 17.6205 25C18.9759 25 19.8795 24.6988 20.6325 24.3976C21.3855 24.0964 22.1386 23.6446 22.8916 22.8916C23.6446 22.1386 23.9458 21.5361 24.3976 20.6325C24.6988 19.8795 24.8494 18.9759 25 17.6205C25 16.2651 25 15.8133 25 12.5C25 9.18675 25 8.73494 25 7.37952C25 6.0241 24.6988 5.12048 24.3976 4.36747C24.0964 3.61446 23.6446 2.86145 22.8916 2.10843C22.1386 1.35542 21.5361 1.05422 20.6325 0.60241C19.8795 0.301206 18.9759 0.150602 17.6205 0C16.2651 0 15.9639 0 12.5 0Z"
              class="duration-300 transition-color"
              :class="
                hover == 'instagram'
                  ? 'md:fill-main-color fill-white md:opacity-100 opacity-30'
                  : 'md:fill-zinc-400 fill-white'
              "
            />
            <path
              d="M12.5 6.0241C8.88554 6.0241 6.0241 8.88554 6.0241 12.5C6.0241 16.1145 8.88554 18.9759 12.5 18.9759C16.1145 18.9759 18.9759 16.1145 18.9759 12.5C18.9759 8.88554 16.1145 6.0241 12.5 6.0241ZM12.5 16.7169C10.241 16.7169 8.28313 14.9096 8.28313 12.5C8.28313 10.241 10.0904 8.28313 12.5 8.28313C14.759 8.28313 16.7169 10.0904 16.7169 12.5C16.7169 14.759 14.759 16.7169 12.5 16.7169Z"
              class="duration-300 transition-color"
              :class="
                hover == 'instagram'
                  ? 'md:fill-main-color fill-white md:opacity-100 opacity-30'
                  : 'md:fill-zinc-400 fill-white'
              "
            />
            <path
              d="M19.1265 7.37952C19.9583 7.37952 20.6325 6.70525 20.6325 5.8735C20.6325 5.04174 19.9583 4.36747 19.1265 4.36747C18.2948 4.36747 17.6205 5.04174 17.6205 5.8735C17.6205 6.70525 18.2948 7.37952 19.1265 7.37952Z"
              class="duration-300 transition-color"
              :class="
                hover == 'instagram'
                  ? 'md:fill-main-color fill-white md:opacity-100 opacity-30'
                  : 'md:fill-zinc-400 fill-white'
              "
            />
          </svg>
        </a>
        <a
          class="cursor-pointer"
          @mouseenter="hover = 'youtube'"
          @mouseleave="hover = ''"
          :href="footer_data.company_youtube.content"
          target="_blank"
        >
          <svg
            width="26"
            height="18"
            viewBox="0 0 26 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25.0714 2.73214C24.75 1.60714 23.9464 0.803572 22.8214 0.482143C20.8929 2.8738e-07 12.6964 0 12.6964 0C12.6964 0 4.66072 2.8738e-07 2.57144 0.482143C1.44644 0.803572 0.642852 1.60714 0.321424 2.73214C-4.9094e-06 4.82143 0 9 0 9C0 9 4.88545e-06 13.1786 0.482148 15.2679C0.803576 16.3929 1.60714 17.1964 2.73214 17.5179C4.66071 18 12.8571 18 12.8571 18C12.8571 18 20.8928 18 22.9821 17.5179C24.1071 17.1964 24.9107 16.3929 25.2322 15.2679C25.7143 13.1786 25.7143 9 25.7143 9C25.7143 9 25.7143 4.82143 25.0714 2.73214ZM10.2857 12.8571V5.14286L17.0357 9L10.2857 12.8571Z"
              class="duration-300 transition-color"
              :class="
                hover == 'youtube'
                  ? 'md:fill-main-color fill-white md:opacity-100 opacity-30'
                  : 'md:fill-zinc-400 fill-white'
              "
            />
          </svg>
        </a>
      </div>
    </div>

    <div
      data-panel-left
      class="relative items-center justify-center hidden w-1/2 h-full left_panel bg-main-color md:flex"
    >
      <img
        data-panel-logo
        class="relative z-10 w-64"
        src="/img/menu/web_menu_logo.webp"
        alt="SavageBull"
      />
      <img
        data-panel-logo
        class="absolute top-1/2 left-1/2 transform z-[9] w-64 mix-blend-color"
        src="/img/menu/web_menu_logo_green.webp"
        alt="SavageBull Background Image"
      />
      <img
        data-panel-logo
        class="absolute top-1/2 left-1/2 transform z-[9] w-64 mix-blend-color-dodge"
        src="/img/menu/web_menu_logo_blue.webp"
        alt="SavageBull Background Image"
      />
      <div
        class="absolute top-0 bottom-0 left-0 right-0 z-0 mix-blend-multiply opacity-20"
        style="
          background-image: url('/img/bg_texture.webp');
          background-size: 80px;
        "
      ></div>
    </div>

    <div
      data-panel-right
      class="relative flex items-center justify-start w-full h-full pl-12 right_panel md:w-1/2 md:bg-white bg-main-color"
    >
      <ol class="relative z-10">
        <li
          v-for="(item, item_index) in menu_list"
          :key="item.id"
          class="mb-6 overflow-hidden transition-transform duration-300 transform hover:translate-x-6"
          @mouseenter="hover_menu_item = item_index"
          @mouseleave="hover_menu_item = -1"
        >
          <router-link
            :to="item.link"
            @click.native="Close()"
            class="block"
            data-panel-link
          >
            <h4
              class="text-2xl leading-none text-white font-audiowide md:text-main-color sm:text-3xl"
            >
              {{ item.sub_title }}
            </h4>
            <p
              class="font-medium transition-colors duration-300"
              :class="
                hover_menu_item == item_index
                  ? 'md:text-main-color text-zinc-300'
                  : 'md:text-zinc-400 text-zinc-800'
              "
            >
              {{ item.title }}
            </p>
          </router-link>
        </li>
      </ol>
      <div
        class="absolute top-0 bottom-0 left-0 right-0 z-0 mix-blend-multiply opacity-20"
        style="
          background-image: url('/img/bg_texture.webp');
          background-size: 80px;
        "
      ></div>
    </div>
  </div>
</template>

<script>
import { menu } from '@/gsap/main_menu';
import close_icon from '@/components/svg/close_icon.vue';
export default {
  name: 'MainMenu',

  components: {
    close_icon,
  },
  data() {
    return {
      hover: '',
      hover_close_btn: false,
      hover_menu_item: -1,
      menu_list: [
        {
          title: '首頁',
          sub_title: 'HOME PAGE',
          link: '/',
        },
        {
          title: '最新消息',
          sub_title: 'NEWS',
          link: '/News',
        },
        {
          title: '關於我們',
          sub_title: 'ABOUT US',
          link: '/About',
        },
        {
          title: '產品列表',
          sub_title: 'PRODUCTS',
          link: '/Product',
        },
        {
          title: '下載專區',
          sub_title: 'DOWNLOADS',
          link: '/Download',
        },
        {
          title: '客製化選色',
          sub_title: 'CUSTOMIZE',
          link: '/ColorSelector',
        },
        {
          title: '聯絡我們',
          sub_title: 'CONTACT US',
          link: '/Contact',
        },
      ],
      menu_animation: null,
    };
  },
  computed: {
    footer_data() {
      return this.$store.state.footer_data;
    },
  },
  methods: {
    Open() {
      this.menu_animation.open();
    },
    Close() {
      this.menu_animation.close();
    },
  },
  mounted() {
    this.menu_animation = new menu(this.$refs.MainContent);
  },
  created() {
    this.footer_data == null ? this.$store.dispatch('GetFooterData') : '';
  },
};
</script>

<style>
#MainMenu .social_box {
  left: calc(50% + 60px);
}

#MainMenu .bottom_line {
  left: calc(50% + 40px);
}

@media (max-width: 768px) {
  #MainMenu .social_box {
    left: calc(80px);
  }
}
@media (max-width: 600px) {
  #MainMenu .social_box {
    left: calc(40px);
  }
}
</style>
